import React from 'react';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { useSelector } from 'react-redux';
import { getErrorSuccessLoaderLabels } from 'redux/modules/dynamicLabels/selectors';
import loaderIcon from 'assets/img/icons/loader.svg';
import styles from 'assets/jss/material-dashboard-pro-react/views/loaderStyle';

// @ts-ignore
const useStyles = makeStyles(styles);

const Loader = () => {
	const classes = useStyles();
	const loaderLabels = useSelector(getErrorSuccessLoaderLabels);

	return (
		<div className={classes.loaderWrapper} aria-describedby="loading-text">
			<Box component="div">
				<img className={classes.loader} src={loaderIcon} alt="" role="presentation" />
			</Box>
			<p id="loading-text" className={classes.loadingText}>
				{loaderLabels?.loadingMessages?.loaderText}
			</p>
		</div>
	);
};

export default Loader;
